import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CompaniesUpdateRequest, CompanyFeatureFlagToggle, CompanyFlags, FeatureFlag, FeatureFlagOverview, FeatureFlagRequest, RolloutRequest } from 'voxloud-types/dist/models';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = '/api/v1/feature-flags';

  getAllFeatureFlags(): Observable<FeatureFlag[]> {
    return this.http.get<FeatureFlag[]>(
      `${environment.apiEndpoint}${this.baseUrl}`
    );
  }

  getFeatureFlagById(flagId: number): Observable<FeatureFlag> {
    return this.http.get<FeatureFlag>(
      `${environment.apiEndpoint}${this.baseUrl}/${flagId}`
    );
  }

  createFeatureFlag(body: FeatureFlagRequest): Observable<FeatureFlag> {
    return this.http.post<FeatureFlag>(
      `${environment.apiEndpoint}${this.baseUrl}`, 
      body
    );
  }

  updateFeatureFlag(flagId: number, body: FeatureFlagRequest): Observable<FeatureFlag> {
    return this.http.put<FeatureFlag>(
      `${environment.apiEndpoint}${this.baseUrl}/${flagId}`, 
      body
    );
  }

  deleteFeatureFlag(flagId: number): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiEndpoint}${this.baseUrl}/${flagId}`
    );
  }
  
  setRolloutPercentage(flagId: number, body: RolloutRequest): Observable<FeatureFlag> {
    return this.http.put<FeatureFlag>(
      `${environment.apiEndpoint}${this.baseUrl}/${flagId}/rollout`, 
      body
    );
  }

  updateFlagCompanies(flagId: number, body: CompaniesUpdateRequest): Observable<FeatureFlag> {
    return this.http.put<FeatureFlag>(
      `${environment.apiEndpoint}${this.baseUrl}/${flagId}/companies`,
      body
    );
  }

  enableFlagForCompany(flagId: number, companyId: number): Observable<CompanyFeatureFlagToggle> {
    return this.http.post<CompanyFeatureFlagToggle>(
      `${environment.apiEndpoint}${this.baseUrl}/${flagId}/companies/${companyId}`, 
      {}
    )
  }

  disableFlagForCompany(flagId: number, companyId: number): Observable<CompanyFeatureFlagToggle> {
    return this.http.delete<CompanyFeatureFlagToggle>(
      `${environment.apiEndpoint}${this.baseUrl}/${flagId}/companies/${companyId}`
    );
  }

  getFeatureFlagOverview(flagId: number): Observable<FeatureFlagOverview> {
    return this.http.get<FeatureFlagOverview>(
      `${environment.apiEndpoint}${this.baseUrl}/${flagId}/overview`
    )
  }

  getCompanyFeatureFlags(companyId: number, showDetails: boolean = false): Observable<CompanyFlags> {
    return this.http.get<CompanyFlags>(
      `${environment.apiEndpoint}${this.baseUrl}/companies/${companyId}?detail=${showDetails}`
    )
  }
}
